import { Facebook, Linkedin, Youtube, Instagram } from "lucide-react";
import { SOCIALS } from "@/lib/api";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden {...props}>
    <path d="M16.5 3c.3 2.1 1.6 3.6 3.7 3.9v2.4c-1.3.1-2.5-.3-3.7-1v6.4c0 3.3-2.5 5.6-5.6 5.6-3 0-5.4-2.3-5.4-5.3 0-3.1 2.6-5.5 5.9-5.1v2.5c-.4-.1-.9-.2-1.3-.1-1.3.2-2.2 1.2-2.1 2.6.1 1.3 1.2 2.3 2.5 2.2 1.4-.1 2.3-1.1 2.3-2.6V3h3.2z" />
  </svg>
);

const iconFor = (name) => {
  if (name === "Facebook") return <Facebook size={18} />;
  if (name === "LinkedIn") return <Linkedin size={18} />;
  if (name === "YouTube") return <Youtube size={18} />;
  if (name === "Instagram") return <Instagram size={18} />;
  return <TikTok />;
};

// Reusable social icon row. `variant` themes it for light or dark backgrounds.
export const SocialLinks = ({ group = "brand", variant = "dark", testidPrefix = "social" }) => {
  const base =
    "h-11 w-11 grid place-items-center rounded-full border transition-colors duration-300";
  const theme =
    variant === "light"
      ? "border-ink/25 text-ink hover:bg-ink hover:text-white hover:border-ink"
      : "border-white/25 text-white hover:bg-canary hover:text-ink hover:border-canary";
  const label = group === "brand" ? "The Canary Report" : "Summer Nettles";

  return (
    <div className="flex flex-wrap gap-3">
      {SOCIALS[group].map((s) => (
        <a
          key={s.name}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testidPrefix}-${group}-${s.name.toLowerCase()}`}
          aria-label={`${label} on ${s.name}`}
          className={`${base} ${theme}`}
        >
          {iconFor(s.name)}
        </a>
      ))}
    </div>
  );
};
